import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { MAP } from 'react-google-maps/lib/constants';
import _find from 'lodash/find';
import _some from 'lodash/some';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import _orderBy from 'lodash/orderBy';
import _isEqual from 'lodash/isEqual';
import _debounce from 'lodash/debounce';

// State
import * as restaurantActions from '../../../state/modules/restaurant/actions';
import { mapLocaleSelector } from '../../../state/modules/intl/selectors';

// Components
import { GMaps } from '../../GoogleMap';
import Paper from '../../Paper';
import Form from '../../Form';

// Icons
import ClearIcon from '../../../icons/close.svg';
import SearchIcon from '../../../icons/search.svg';
// import clockIcon from '../assets/clock-small.svg';
// import locationIcon from '../assets/location.svg';

// Partials
import MapInfoWindow from '../MapInfoWindow';
import MapPlacemarks from './MapPlacemarks';
import MapPolygons from './MapPolygons';

// Config
import config from '../../../config';

// Styles
import styles from '../ContactsMap.styl';

const cx = classNames.bind(styles);

class ContactsMapGoogle extends PureComponent {
  static defaultProps = {
    className: '',
    mapState: {
      controls: [],
    },
  };

  static propTypes = {
    className: PropTypes.string,
    center: PropTypes.array.isRequired,
    mapState: PropTypes.object.isRequired,
    isPhone: PropTypes.bool.isRequired,
    restaurant: PropTypes.object,
    intl: PropTypes.object,
    mapLocale: PropTypes.string,
    userCity: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  constructor(props) {
    super(props);
    this.debouncedPolygonClick = _debounce(this.polygonClick, 100);

    this.searchInput = React.createRef();

    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
  }

  state = {
    selectedPolygonId: undefined,
    selectedRestaurantId: undefined,
    deliveryGroups: [],
    isMarkerHover: false,
    allMarkersVisible: false,
    hintLayout: null,
    isLoaded: false,
    uniqueCategory: undefined,
    activeCategory: 'day',
    activeTab: 'day',
    searchValue: '',
    isNoResultMessage: false,
    tempSelectedMap: {
      selectedPolygonId: undefined,
      selectedRestaurantId: undefined,
    },
  };

  componentDidMount() {
    const { restaurant } = this.props;

    if (restaurant.isLoaded) {
      this.getUniqueCategory(restaurant.list);
      this.getDeliveryGroups(restaurant.list, this.state.activeCategory);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.restaurant.isLoaded && !_isEqual(nextProps.restaurant, this.props.restaurant)) {
      this.getUniqueCategory(nextProps.restaurant.list);
      this.getDeliveryGroups(nextProps.restaurant.list, this.state.activeCategory);
    }
  }

  componentWillUnmount() {
    this.clearResultMessage();

    if (this.mapRef && this.mapRef.context[MAP]) {
      google.maps.event.clearListeners(this.mapRef.context[MAP], 'place_changed');
    }

    const { searchForm } = this.refs;

    if (searchForm) {
      searchForm.removeEventListener('submit', this.submitListener, false);
    }
  }

  showNoResultMessage = () => {
    this.clearResultMessage();
    this.setState({ isNoResultMessage: true });

    this.timer = setTimeout(() => {
      this.setState({ isNoResultMessage: false });
    }, 5000);
  };

  clearResultMessage = () => {
    this.setState({ isNoResultMessage: false });

    // searchForm.removeEventListener('submit'

    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  getUniqueCategory = list => {
    const category = new Set();
    list.map(area => area.areas_details.map(item => category.add(item.category)));

    this.setState({ uniqueCategory: category });
  };

  colors = [
    '#009471',
    'rgb(242, 201, 77)',
    'rgb(194, 19, 19)',
    'rgb(161, 78, 160)',
    'rgb(150, 221, 231)',
    'rgb(52, 92, 186)',
    'rgb(219, 103, 148)',
    'rgb(77, 209, 189)',
    'rgb(217, 148, 74)',
  ];
  getDeliveryGroups = (list, activeCategory) => {
    const deliveryGroups = [];

    list.map(area =>
      _filter(area.areas_details, { category: activeCategory }).map(item =>
        deliveryGroups.push({ min_sum: item.min_sum, max_sum: item.max_sum }),
      ),
    );

    const deliveryGroupsUniq = _orderBy(_uniqBy(deliveryGroups, 'min_sum'), ['min_sum'], ['asd']);
    _map(deliveryGroupsUniq, (el, i) => {
      el.color = this.colors[i];
    });

    this.setState({
      deliveryGroups: deliveryGroupsUniq,
    });
  };

  polygonClick = (restaurantId, polygonId) => {
    const currentId = this.state.selectedPolygonId === polygonId ? undefined : polygonId;

    if (this.state.activeCategory === 'day') {
      this.setState({
        selectedPolygonId: currentId,
        selectedRestaurantId: currentId ? restaurantId : undefined,
        tempSelectedMap: {
          selectedPolygonId: currentId,
          selectedRestaurantId: currentId ? restaurantId : undefined,
        },
      });
    } else {
      this.setState({
        selectedPolygonId: currentId,
        selectedRestaurantId: currentId ? restaurantId : undefined,
        tempSelectedMap: {
          selectedPolygonId: undefined,
          selectedRestaurantId: undefined,
        },
      });
    }
  };

  markerHover = bool => this.setState({ isMarkerHover: bool });

  cleanSearch = () => {
    this.refs.searchInput.value = '';
    this.refs.searchInput.focus();

    if (this.userMarker && typeof this.userMarker.setMap === 'function') {
      this.userMarker.setMap(null);
      this.mapRef.context[MAP].setZoom(10);
    }

    this.setState({ searchValue: '' });
  };

  checkWorkingAtNight = item => {
    return _some(item.areas_details, { category: this.state.activeCategory });
  };

  handleClickTab = value => {
    if (value !== this.state.activeTab) {
      this.setState({
        activeTab: value,
        activeCategory: value,
        selectedPolygonId: this.state.tempSelectedMap.selectedPolygonId,
        selectedRestaurantId: this.state.tempSelectedMap.selectedRestaurantId,
        isMarkerHover: false,
      });

      return this.getDeliveryGroups(this.props.restaurant.list, value);
    }
    return false;
  };

  searchOnChange = input => {
    this.setState({ searchValue: input.target.value });
    this.clearResultMessage();
  };

  getMapRef = map => {
    this.mapRef = map;

    if (this.mapRef) {
      const { searchForm, searchInput } = this.refs;
      const { userCity } = this.props;

      const isMoscow =
        ['Москва', 'Балашиха', 'Зеленоград', 'Королев', 'Мытищи', 'Щелково'].indexOf(
          userCity.name,
        ) !== -1;

      const inputWithCity = searchInput;

      const moscowBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(56.062224, 36.610939),
        new google.maps.LatLng(55.132283, 38.415443),
      );

      let autocompleteBounds = isMoscow ? moscowBounds : null;
      if (!autocompleteBounds && userCity.coordinates && config.legal === 'pl') {
        const lng = parseFloat(userCity.coordinates[0]);
        const lat = parseFloat(userCity.coordinates[1]);
        const cityRadiusMeters = userCity.autocomplete_radius_meters ?? 20000;
        const circle = new google.maps.Circle({
          radius: cityRadiusMeters,
          center: { lng, lat },
        });
        autocompleteBounds = circle.getBounds();
      }

      this.placesService = new google.maps.places.PlacesService(this.mapRef.context[MAP]);

      this.suggService = new google.maps.places.Autocomplete(inputWithCity, {
        bounds: autocompleteBounds,
        strictBounds: Boolean(autocompleteBounds),
        componentRestrictions: { country: [config.legal] },
      });
      this.suggService.bindTo('bounds', this.mapRef.context[MAP]);

      this.suggService.addListener('place_changed', this.handlePlaceSelect);
      searchForm.addEventListener('submit', this.submitListener, false);

      this.setState({
        isLoaded: true,
      });
    }
  };

  submitListener = e => {
    e.preventDefault();

    if (searchInput.value) {
      this.getPlaceOnMap(searchInput.value);
    }
  };

  handlePlaceSelect() {
    const { name } = this.suggService.getPlace();

    if (name) {
      this.getPlaceOnMap(name);
    }
  }

  getPlaceOnMap = value => {
    const request = {
      query: value,
      fields: ['name', 'geometry'],
      locationBias: {
        lng: parseFloat(this.props.userCity.coordinates[0]),
        lat: parseFloat(this.props.userCity.coordinates[1]),
      },
    };

    this.placesService.textSearch(request, (results, status) => {
      if (this.userMarker && typeof this.userMarker.setMap === 'function') {
        this.userMarker.setMap(null);
      }

      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const bounds = new google.maps.LatLngBounds();

        results.map(place => {
          if (!place.geometry) {
            return;
          }

          this.userMarker = new google.maps.Marker({
            map: this.mapRef.context[MAP],
            // icon: locationIcon,
            title: place.name,
            position: place.geometry.location,
          });

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        this.mapRef.fitBounds(bounds);
      }
    });
  };

  onZoomChanged = () => {
    if (this.mapRef.getZoom() >= 12) {
      this.setState({ allMarkersVisible: true });
    } else {
      this.setState({ allMarkersVisible: false });
    }
  };

  switchRouteWindow = () => {
    return false;
  };

  render() {
    const {
        className,
        center,
        mapState,
        restaurant,
        userCity,
        mapLocale,
        isPhone,
        intl,
      } = this.props,
      {
        isLoaded,
        hintLayout,
        uniqueCategory,
        deliveryGroups,
        allMarkersVisible,
        selectedPolygonId,
        isMarkerHover,
        selectedRestaurantId,
        searchValue,
      } = this.state;

    const mapStateInstance = {
      ...mapState,
      zoom: userCity.zoom || 10,
      center: center,
    };

    const currentRestarant = _find(restaurant.list, { id: selectedRestaurantId }) || {};

    return (
      <div className={cx('Map', className)}>
        <div className={cx('Map__inner')}>
          <GMaps
            loadingElement={<div className={cx('Map__preloader')} />}
            containerElement={<div className={cx('Map__layout')} />}
            mapElement={<div style={{ width: '100%', height: '100%', zIndex: '2' }} />}
            defaultZoom={mapStateInstance.zoom}
            defaultCenter={mapStateInstance.center}
            onZoomChanged={this.onZoomChanged} // TODO: here
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              gestureHandling: 'auto',
            }}
            getMapRef={this.getMapRef}
          >
            {restaurant.isLoaded &&
              restaurant.list.map(item => {
                if (this.checkWorkingAtNight(item)) {
                  return (
                    <MapPlacemarks
                      key={item.id}
                      item={item}
                      hintLayout={hintLayout}
                      selectedPolygonId={selectedPolygonId}
                      markerHover={this.markerHover}
                      allMarkersVisible={allMarkersVisible}
                    />
                  );
                } else {
                  return false;
                }
              })}
            {restaurant.isLoaded &&
              restaurant.list.map(item => {
                if (this.checkWorkingAtNight(item)) {
                  return _filter(item.areas_details, {
                    category: this.state.activeCategory,
                  }).map(area => (
                    <MapPolygons
                      key={area.polygon_id}
                      restaurantId={item.id}
                      item={area}
                      name={item.name}
                      hintLayout={hintLayout}
                      isMarkerHover={isMarkerHover}
                      selectedPolygonId={selectedPolygonId}
                      polygonClick={this.debouncedPolygonClick}
                      currency={userCity.currency.unit}
                      deliveryGroups={deliveryGroups}
                      isOpeningSoon={item.opening_soon}
                    />
                  ));
                } else {
                  return false;
                }
              })}
            {/*<MapSearchBox userCity={userCity} children={this.searchInput.current} />*/}
          </GMaps>

          <Paper className={cx('Map__toolbar')} style={{ zIndex: 2 }}>
            <div className={cx('Map__search', { [`Map__search_disabled`]: !isLoaded })}>
              <form ref="searchForm" action="/">
                <div className={cx('Map__searchField', { Map__searchField_dirty: searchValue })}>
                  <div className={cx('Map__searchIcon')}>
                    <SearchIcon width={24} height={24} />
                  </div>
                  <input
                    ref="searchInput"
                    type="text"
                    placeholder={intl.formatMessage({
                      id: 'page.contacts.searchAddress.placeholder',
                    })}
                    className={cx('Map__searchInput')}
                    onChange={this.searchOnChange}
                  />
                  <div className={cx('Map__searchCleaner')} onClick={this.cleanSearch}>
                    <ClearIcon width={16} height={16} />
                  </div>
                </div>
              </form>
              {this.state.isNoResultMessage && (
                <Form.Error
                  className={cx('Map__searchError')}
                  error={this.props.intl.formatMessage({ id: 'contactsMap.search.noResult' })}
                />
              )}
            </div>
            {restaurant.isLoaded && (
              <MapInfoWindow
                isPhone={isPhone}
                selectedPolygonId={selectedRestaurantId}
                restaurants={restaurant.list}
                currentRestarant={currentRestarant}
                switchRouteWindow={this.switchRouteWindow}
                isButtonRoute={false}
              />
            )}
          </Paper>

          {uniqueCategory && isLoaded && (
            <Paper className={cx('Map__legend')} style={{ zIndex: 2 }}>
              <div className={cx('Map__legendGroup')}>
                <div className={cx('Map__legendTabs')}>
                  {uniqueCategory.has('day') && (
                    <div
                      className={cx('Map__legendTab', {
                        Map__legendTab_active: this.state.activeTab === 'day',
                      })}
                      onClick={() => this.handleClickTab('day')}
                    >
                      <FormattedMessage id="page.contacts.legend.tabs.day" />
                    </div>
                  )}
                  {/*uniqueCategory.has('night') && (
                      <div
                        className={cx('Map__legendTab', {
                          Map__legendTab_active: this.state.activeTab === 'night',
                        })}
                        onClick={() => this.handleClickTab('night')}>
                        <FormattedMessage id="page.contacts.legend.tabs.night" />
                      </div>
                      )*/}
                </div>
                <div className={cx('Map__legendText')}>
                  <FormattedMessage id="page.contacts.freeDelivery.label" />
                </div>
                <div className={cx('Map__legendItems')}>
                  {this.state.deliveryGroups &&
                    _map(this.state.deliveryGroups, (group, key) => (
                      <div
                        key={key}
                        className={cx('Map__legendItem')}
                        style={{ color: group.color }}
                      >
                        <div className={cx('Map__legendLabel')}>
                          &mdash;&nbsp;
                          <FormattedMessage id="amount.prefix" />
                          &nbsp;
                          {group.min_sum}&nbsp;{userCity.currency.unit}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Paper>
          )}
        </div>
      </div>
    );
  }
}

const connector = connect(
  state => ({
    restaurant: state.restaurant,
    userCity: state.city.userCity,
    mapLocale: mapLocaleSelector(state),
    isPhone: state.responsive.isPhone,
  }),
  dispatch => bindActionCreators(restaurantActions, dispatch),
);

export default injectIntl(connector(ContactsMapGoogle));
